<template>
  <SearchDropdown
    :value="value"
    :search-result-items="searchResultItems"
    :loading="isResultLoading"
    :item-text="itemText"
    :input-prompt-text="inputPromptText"
    :not-found-text="notFoundText"
    :label="label"
    :error-messages="errorMessages"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @search="triggerSearch"
  />
</template>

<script>
import { navigateToQueryResult } from "@/components/ui/form/query_search_dropdown/queryResultNavigator.js";

import SearchDropdown from "@/components/ui/form/search_dropdown.vue";

/*
 * Wrapper component for SearchDropdown, so that the query and
 * search triggering is already handled from within the component.
 */

export default {
  name: "QuerySearchDropdown",
  components: { SearchDropdown },
  props: {
    // value for v-model
    value: {
      required: false,
    },
    // GraphQL Query
    query: {
      type: Object,
      required: true,
    },
    // Which key to use from GraphQL query response
    queryKey: {
      type: [Array, String],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    // Which key to use to display each item from the search results
    itemText: {
      type: String,
      required: true,
    },
    inputPromptText: {
      type: String,
      required: false,
      default: "Digite para pesquisar...",
    },
    notFoundText: {
      type: String,
      required: false,
      default: "Nenhum registro encontrado.",
    },
    errorMessages: {
      type: [String, Array],
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Which key is to be sent when triggering the search
    searchParamKey: {
      type: String,
      required: false,
      default: "searchQuery",
    },
    additionalVariables: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  apollo: {
    searchResultItems: {
      query() {
        return this.query;
      },
      update(data) {
        return navigateToQueryResult(data, this.queryKey);
      },
      variables() {
        return {
          ...this.additionalVariables,
          [this.searchParamKey]: this.searchParamValue,
        };
      },
      skip() {
        return !this.searchParamValue;
      },
    },
  },
  data() {
    return {
      searchResultItems: [],
      searchParamValue: null,
    };
  },
  watch: {
    value(value) {
      this.updateSearchQueryWithExistingValue(value);
    },
  },
  computed: {
    isResultLoading() {
      return this.$apollo.queries.searchResultItems.loading;
    },
  },
  methods: {
    triggerSearch(search) {
      this.searchParamValue = search;
      this.$apollo.queries.searchResultItems.skip = false;
    },
    updateSearchQueryWithExistingValue(value) {
      const newSearchQuery = value ? value[this.itemText] : "";

      this.searchParamValue = newSearchQuery;
    },
  },
};
</script>

<style scoped></style>
